// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"6a23f468","382":"c9c860d8","428":"09858637","453":"56fb65f7","678":"2bb1293d","706":"42f3f9d8","858":"4e5d78a5","978":"4a0298b4"}[chunkId] + ".chunk.js";
};